var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roleCell"},[_c('img',{attrs:{"src":_vm.photo}}),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("123")]),_c('div',[_vm._v("123")])])}]

export { render, staticRenderFns }